var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtbId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37303 4.79999L4.0284 8.48833H22.6554L24 4.79999H5.37303ZM3.35687 10.3309L2.01225 14.0185H20.6392L21.9838 10.3309H3.35687ZM1.34463 15.8619L0 19.5486H18.627L19.97 15.8611C19.9708 15.8619 1.34463 15.8619 1.34463 15.8619Z",
    fill: "#2665E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtbId);
export default __webpack_public_path__ + "static/media/vtb-id.59112fa1dae08bf2b39783a2bb6487dd.svg";
export { ForwardRef as ReactComponent };